/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import { useState, useEffect } from "react";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 MUI base styles
import typography from "assets/theme/base/typography";

// Company service
import { getCompany } from "services/companyService";

function Footer(
  company = { href: "https://www.creative-tim.com/", name: "Creative Tim" },
  links = [
    // { href: "https://www.creative-tim.com/", name: "Creative Tim" },
    // { href: "https://www.creative-tim.com/presentation", name: "About Us" },
    // { href: "https://www.creative-tim.com/blog", name: "Blog" },
    // { href: "https://www.creative-tim.com/license", name: "License" },
  ]
) {
  const { href, name } = company;
  const { size } = typography;
  const [companyName, setCompanyName] = useState("Edushala Academy");

  // Fetch company name dynamically
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await getCompany();
        if (response.success && response.data && response.data.name) {
          setCompanyName(response.data.name);
        }
      } catch (error) {
        console.error("Failed to fetch company data:", error);
        // Keep default name if fetch fails
      }
    };
    fetchCompanyData();
  }, []);

  const renderLinks = () =>
    links.map((link) => (
      <ArgonBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <ArgonTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </ArgonTypography>
        </Link>
      </ArgonBox>
    ));

  return (
    <ArgonBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <ArgonBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        &copy; {new Date().getFullYear()}{" "}
        <ArgonTypography
          variant="button"
          textTransform="none"
          color="primary"
          mx={1}
          fontWeight="medium"
        >
          {companyName} Academy
        </ArgonTypography>
        <ArgonBox fontSize={size.md} color="text" mb={-0.5} mx={0.25}>
          {/* <Icon color="inherit" fontSize="inherit">
            
          </Icon> */}
        </ArgonBox>
        <Link href={href} target="_blank">
          <ArgonTypography variant="button" fontWeight="medium">
            &nbsp;{name}&nbsp;
          </ArgonTypography>
        </Link>
      </ArgonBox>
      <ArgonBox
        component="ul"
        sx={({ breakpoints }) => ({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up("lg")]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </ArgonBox>
    </ArgonBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: { href: "https://www.creative-tim.com/", name: "Creative Tim" },
  links: [
    { href: "https://www.creative-tim.com/", name: "Creative Tim" },
    { href: "https://www.creative-tim.com/presentation", name: "About Us" },
    { href: "https://www.creative-tim.com/blog", name: "Blog" },
    { href: "https://www.creative-tim.com/license", name: "License" },
  ],
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
